<template>
  <div class="loadingScreen">
    <v-container
    fill-height
    style="height: 100vh;"
    >
        <v-layout align-center>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4">
                        <div class="text-center">
                            <v-progress-circular
                                :size="128"
                                color="primary"
                                indeterminate
                            ></v-progress-circular>
                            <p
                            color="primary"
                            >Loading...</p>
                        </div>
                </v-col>
            </v-row>
        </v-layout>
    </v-container>   
  </div>
</template>


<script>
import firebase from '@/fb';

export default {
    name: 'LoadingScreen',
    
    props: {
        params: Object
    },
    mounted (){
        //Once mounted and the firebase userDB + orgDB is populated, call the dashboard and prop into it
        this.reloadFirebase();
    },
    methods: {
        async reloadFirebase(){
            await this.getUser();
        },
        //Firebase call to get user database item
        async getUser(){
            var that = this;
            firebase.db.collection("users").where("uid", "==", this.$route.params.user.uid)
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    const data = {
                    uid: doc.data().uid,
                    displayname: doc.data().displayname,
                    firstname: doc.data().firstname,
                    surname: doc.data().surname,
                    photo: doc.data().photo,
                    email: doc.data().email,
                    treatments: doc.data().treatments,
                    orgid: doc.data().orgid,
                    orgadmin: doc.data().orgadmin,
                    activity: doc.data().activity,
                    premium: doc.data().premium,
                    faveTreatments: doc.data().faveTreatments,
                    faveCases: doc.data().faveCases
                    }
                    that.userDb =  data;
                    that.getOrganisation();
                });        
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error); // eslint-disable-line no-console
                that.userDb = error;
            });
        },    
        //Firebase call to get organisation database item
        async getOrganisation(){
            var that = this;
            firebase.db.collection("organisations").where("id", "==", this.userDb.orgid)
            .get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        const data = {
                        id: doc.data().id,
                        name: doc.data().name,
                        bio: doc.data().bio,
                        location: doc.data().location,
                        maxUsers: doc.data().maxUsers,
                        users: doc.data().users,
                        treatments: doc.data().treatments
                    }
                    that.orgDb = data;
                });
                //Once loaded, push in the dashboard
                that.$router.push({name: 'DashboardPage', params: { user: that.$route.params.user, loginStatus: that.$route.params.loginStatus, userDb: that.userDb, orgDb: that.orgDb}});
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error); // eslint-disable-line no-console
                that.orgDb = error;
            });
        }
    },
    data: () => ({
        userDb: {},
        orgDb: {}
    }),
}
</script>